import { shorterCssColorNames } from './shorter-css-color-names';

const REGEX = {
  whitespace: /\s+/g,
  urlHexPairs: /%[\dA-F]{2}/g,
  quotes: /"/g,
};

function collapseWhitespace(str: string) {
  return str.trim().replace(REGEX.whitespace, ' ');
}

function dataURIPayload(str: string) {
  return encodeURIComponent(str).replace(REGEX.urlHexPairs, specialHexEncode);
}

function colorCodeToShorterNames(str: string) {
  (Object.keys(shorterCssColorNames) as Array<keyof typeof shorterCssColorNames>).forEach(function (key) {
    if (shorterCssColorNames[key].test(str)) {
      str = str.replace(shorterCssColorNames[key], key);
    }
  });

  return str;
}

function specialHexEncode(match: string) {
  switch (
    match
  ) {
    case '%20':
      return ' ';
    case '%3D':
      return '=';
    case '%3A':
      return ':';
    case '%2F':
      return '/';
    default:
      return match.toLowerCase();
  }
}

function svgToTinyDataUri(svgString: string) {
  if (typeof svgString !== 'string') {
    throw new TypeError('Expected a string, but received ' + typeof svgString);
  }
  if (svgString.charCodeAt(0) === 0xfeff) {
    svgString = svgString.slice(1);
  }

  const body = colorCodeToShorterNames(collapseWhitespace(svgString)).replace(REGEX.quotes, "'");
  return 'data:image/svg+xml,' + dataURIPayload(body);
}

svgToTinyDataUri.toSrcset = function toSrcset(svgString: string) {
  return svgToTinyDataUri(svgString).replace(/ /g, '%20');
};

export default svgToTinyDataUri;
